export default __webpack_public_path__ + "static/mission-vision-img-bg-19f0abc8b7b12b0a509b0313dd0e8321.png";